// extracted by mini-css-extract-plugin
export var avatarContainer = "_er-0";
export var gray = "_er-f";
export var green = "_er-c";
export var icon = "_er-9";
export var image = "_er-1";
export var lg = "_er-6";
export var md = "_er-5";
export var presenceDot = "_er-b";
export var red = "_er-d";
export var sm = "_er-4";
export var status = "_er-a";
export var xl = "_er-7";
export var xs = "_er-3";
export var xxl = "_er-8";
export var xxs = "_er-2";
export var yellow = "_er-e";